import React from 'react'
import { FaCocktail } from 'react-icons/fa'

function Lifestyle({ match }) {

    return (
        <>
            <div className='d-flex'>
                <FaCocktail className='match-detail-icon' />
                <div className='match-detail-title'>Lifestyle</div>
            </div>
            <div className='d-flex match-detail-info'>
                <div></div>
                <div>{match?.personalDetails?.diet}</div>
            </div>
        </>
    )
}

export default Lifestyle